import React, { Component } from "react";
export const TickLeft = (props) => {
  return (
    <svg viewBox="0 0 36 36" style={{ height: props.height }}>
      <polygon
        points="0 36 36 0 0 0 0 36"
        fill={props.color}
        style={{ transition: "fill .2s ease" }}
      />
    </svg>
  );
};

export const TickRight = (props) => {
  return (
    <svg viewBox="0 0 36 36" style={{ height: props.height }}>
      <polygon
        points="0 0 36 36 36 0 0 0"
        fill={props.color}
        style={{ transition: "fill .2s ease" }}
      />
    </svg>
  );
};

export const Add = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      style={{ height: props.height, margin: props.margin }}
    >
      {/* <title>add</title> */}
      <style type="text/css">{`.plus0{fill:${props.color}}`}</style>
      {/* <g id="Layer_1" data-name="Layer 1">
        <rect class="plus0" x="14" width="8" height="36" rx="1.1" />
      </g>
      <g id="Layer_2" data-name="Layer 2">
        <rect class="plus0" y="13" width="36" height="8" rx="1.08" />
      </g> */}
      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
        <path
          class="plus0"
          d="M2440 3900 l0 -1220 -1220 0 -1220 0 0 -120 0 -120 1220 0 1220 0 0
-1220 0 -1220 120 0 120 0 0 1220 0 1220 1220 0 1220 0 0 120 0 120 -1220 0
-1220 0 0 1220 0 1220 -120 0 -120 0 0 -1220z"
        />
      </g>
    </svg>
  );
};

export const FollowUpIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{ height: props.height, margin: props.margin }}
    >
      {/* <title>add</title> */}
      <style type="text/css">{`
       .followUp1 {
        fill: none;
      }

      .followUp1, .followUp2 {
        stroke: ${props.color};
        stroke-miterlimit: 10;
        stroke-width: 5px;
      }

      .followUp2 {
        fill: ${props.color};
      }
    `}</style>
      {/* <g id="Layer_1" data-name="Layer 1">
        <rect class="plus0" x="14" width="8" height="36" rx="1.1" />
      </g>
      <g id="Layer_2" data-name="Layer 2">
        <rect class="plus0" y="13" width="36" height="8" rx="1.08" />
      </g> */}
      <circle class="followUp1" cx="30.66" cy="29.37" r="7.51" />
      <circle class="followUp1" cx="30.66" cy="28.78" r="23.82" />
      <circle class="followUp1" cx="30.66" cy="29.37" r="15.71" />
      <polygon
        class="followUp2"
        points="36.04 39.16 41.8 60.64 46.37 56.68 51.76 62.74 59.56 55 53.68 49 57.88 45.09 36.04 39.16"
      />
    </svg>
  );
};

export const AddWhite = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      style={{ height: props.height, margin: props.margin }}
    >
      {/* <title>add</title> */}
      <style type="text/css">{`.plus1{fill:#fff}`}</style>
      {/* <g id="Layer_1" data-name="Layer 1">
        <rect class="plus1" x="14" width="8" height="36" rx="1.1" />
      </g>
      <g id="Layer_2" data-name="Layer 2">
        <rect class="plus1" y="13" width="36" height="8" rx="1.08" />
      </g> */}
      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
        <path
          class="plus1"
          d="M2440 3900 l0 -1220 -1220 0 -1220 0 0 -120 0 -120 1220 0 1220 0 0
-1220 0 -1220 120 0 120 0 0 1220 0 1220 1220 0 1220 0 0 120 0 120 -1220 0
-1220 0 0 1220 0 1220 -120 0 -120 0 0 -1220z"
        />
      </g>
    </svg>
  );
};

export const AddBold = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      style={{ height: props.height, margin: props.margin }}
    >
      {/* <title>add</title> */}
      <style type="text/css">{`.plus2{fill:${props.color}}`}</style>
      <g id="Layer_1" data-name="Layer 1">
        <rect class="plus2" x="14" width="8" height="36" rx="1.1" />
      </g>
      <g id="Layer_2" data-name="Layer 2">
        <rect class="plus2" y="13" width="36" height="8" rx="1.08" />
      </g>
    </svg>
  );
};

export const AddWhiteBold = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      style={{ height: props.height, margin: props.margin }}
    >
      {/* <title>add</title> */}
      <style type="text/css">{`.plus3{fill:#fff}`}</style>
      <g id="Layer_1" data-name="Layer 1">
        <rect class="plus3" x="14" width="8" height="36" rx="1.1" />
      </g>
      <g id="Layer_2" data-name="Layer 2">
        <rect class="plus3" y="13" width="36" height="8" rx="1.08" />
      </g>
    </svg>
  );
};

export const AddGreenBold = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      style={{ height: props.height, margin: props.margin }}
    >
      {/* <title>add</title> */}
      <style type="text/css">{`.plus4{fill:#008910 !important}`}</style>
      <g id="Layer_1" data-name="Layer 1">
        <rect class="plus4" x="14" width="8" height="36" rx="1.1" />
      </g>
      <g id="Layer_2" data-name="Layer 2">
        <rect class="plus4" y="13" width="36" height="8" rx="1.08" />
      </g>
    </svg>
  );
};

export const Filter = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      style={{ height: props.height, margin: props.margin }}
    >
      {/* <title>filter</title> */}
      <style type="text/css">{`.filter0{fill:${props.color}}`}</style>
      <polygon class="filter0" points="0 0 15 25 15 36 21 32 21 25 36 0 0 0" />
    </svg>
  );
};

export const MoveHoriz = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 14"
      style={{ height: props.height, margin: props.margin }}
    >
      {/* <title>move horizontally</title> */}
      <style type="text/css">{`.horiz0{fill:${props.color}}`}</style>
      <circle class="horiz0" cx="18" cy="7" r="4" />
      <polygon class="horiz0" points="0 7 5 0 5 5 13 5 13 9 5 9 5 14 0 7" />
      <polygon
        class="horiz0"
        points="23 5 23 9 31 9 31 14 36 7 31 0 31 5 23 5"
      />
    </svg>
  );
};

export const MoveHoriz1 = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 10"
      style={{ height: props.height, margin: props.margin }}
    >
      {/* <title>move horizontally</title> */}
      <style type="text/css">{`.horiz1{fill:${props.color}} .horiz2{stroke:${props.color};stroke-width: 2px}`}</style>

      <path class="horiz2" d="M19,3V7H11V3h8m1-1H10V8H20V2Z" />
      <polygon class="horiz1" points="10 4 5 4 5 2 0 5 5 8 5 6 10 6 10 4" />
      <polygon
        class="horiz1"
        points="20 6 25 6 25 8 30 5 25 2 25 4 20 4 20 6"
      />
    </svg>
  );
};

export const MoveVertic = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 36"
      style={{ height: props.height, margin: props.margin }}
    >
      {/* <title>move horizontally</title> */}
      <style type="text/css">{`.vertic0{fill:${props.color}}`}</style>

      <circle class="vertic0" cx="7" cy="18" r="4" />
      <polygon class="vertic0" points="7 0 14 5 9 5 9 13 5 13 5 5 0 5 7 0" />
      <polygon
        class="vertic0"
        points="9 23 5 23 5 31 0 31 7 36 14 31 9 31 9 23"
      />
    </svg>
  );
};

export const Settings = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      style={{ height: props.height, margin: props.margin }}
    >
      <defs>
        <style>{`.settings0{fill:${props.color}}`}</style>
      </defs>
      <title xmlns="http://www.w3.org/2000/svg">settings</title>
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          class="settings0"
          d="M2325 5020 c-127 -14 -277 -41 -312 -55 -36 -15 -27 9 -117 -315 -82
-295 -77 -293 -384 -120 -131 74 -223 120 -240 120 -57 0 -294 -180 -467 -355
-170 -172 -335 -391 -335 -445 0 -19 44 -107 120 -242 177 -313 182 -299 -170
-398 -154 -44 -249 -75 -257 -85 -14 -20 -28 -83 -50 -225 -23 -146 -23 -534
0 -680 22 -142 36 -205 50 -224 8 -11 103 -42 257 -86 352 -98 347 -85 170
-398 -77 -136 -120 -223 -120 -242 0 -54 177 -288 345 -455 168 -168 402 -345
457 -345 17 0 109 46 240 120 313 177 300 182 398 -170 44 -157 74 -248 85
-256 21 -15 72 -27 225 -50 161 -25 519 -25 680 0 153 23 204 35 224 49 11 8
42 103 86 257 98 352 85 346 399 170 132 -74 224 -120 242 -120 53 0 287 177
454 345 169 168 345 402 345 456 0 17 -47 111 -120 241 -133 235 -140 259 -92
307 22 22 69 38 262 91 129 36 242 72 251 81 19 19 30 64 55 229 25 161 25
519 0 680 -23 153 -35 204 -50 225 -8 11 -99 41 -256 85 -352 98 -347 85 -170
399 74 132 120 224 120 242 0 55 -182 292 -355 464 -172 170 -391 335 -445
335 -19 0 -107 -44 -242 -120 -313 -177 -299 -182 -398 170 -44 154 -75 249
-85 257 -66 48 -575 88 -800 63z m449 -141 c60 -6 140 -16 179 -23 l71 -11 33
-120 c82 -294 95 -333 126 -370 58 -71 172 -103 258 -73 19 6 116 58 216 115
101 57 186 103 189 103 20 0 229 -167 331 -264 98 -92 301 -335 320 -382 2 -6
-46 -101 -108 -210 -101 -178 -114 -205 -117 -257 -8 -100 44 -194 126 -231
22 -10 131 -44 243 -75 l204 -56 11 -70 c25 -142 37 -340 30 -485 -5 -127 -27
-315 -41 -361 -4 -10 -51 -28 -143 -53 -269 -73 -310 -88 -351 -122 -55 -47
-84 -121 -79 -198 3 -56 13 -77 116 -258 62 -109 112 -201 112 -204 0 -20
-167 -229 -264 -331 -93 -98 -335 -301 -382 -320 -7 -2 -101 46 -210 108 -183
104 -204 114 -260 117 -77 5 -151 -24 -198 -79 -34 -41 -49 -82 -122 -351 -21
-76 -43 -139 -51 -142 -7 -3 -63 -13 -125 -23 -157 -24 -499 -24 -656 0 -62
10 -118 20 -125 23 -8 3 -35 84 -62 182 -60 222 -80 275 -116 317 -44 49 -119
78 -193 73 -56 -3 -77 -13 -260 -117 -109 -62 -203 -110 -210 -108 -19 8 -146
105 -232 178 -104 88 -203 192 -307 324 -126 158 -126 122 -5 336 58 101 110
199 116 218 30 86 -2 200 -73 258 -38 31 -99 52 -370 126 l-119 32 -13 74
c-42 255 -42 528 1 785 l12 71 119 32 c281 77 333 94 373 129 57 48 86 121 79
200 -4 56 -15 79 -116 258 -61 108 -111 199 -111 204 0 14 147 203 226 289
106 117 306 289 410 353 18 11 40 1 205 -92 101 -58 199 -110 218 -116 113
-39 246 21 291 129 8 19 40 124 70 234 l56 200 75 12 c194 32 419 41 603 22z"
        />
        <path
          class="settings0"
          d="M2359 3910 c-413 -65 -772 -312 -982 -675 -61 -105 -112 -232 -145
-363 -25 -99 -27 -123 -27 -312 0 -189 2 -213 27 -312 68 -269 197 -491 392
-675 187 -178 411 -295 666 -350 119 -25 420 -26 537 0 276 59 496 179 694
376 215 216 347 480 390 780 15 106 6 360 -16 461 -57 261 -180 486 -369 676
-147 148 -280 237 -459 309 -164 66 -269 86 -472 90 -99 2 -205 0 -236 -5z
m407 -145 c245 -42 457 -150 638 -325 248 -240 376 -540 376 -880 0 -322 -116
-611 -339 -844 -234 -244 -543 -376 -881 -376 -341 0 -640 127 -880 376 -226
233 -340 517 -340 845 0 587 407 1082 985 1199 115 23 320 25 441 5z"
        />
      </g>
    </svg>
  );
};

export const Modify = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{ height: props.height, margin: props.margin }}
    >
      {/* <title>modify</title> */}
      <style type="text/css">{`.mod0{fill: none;
    stroke: ${props.color};
    stroke-miterlimit: 10;
    stroke-width: 5px;
    }`}</style>
      <path
        class="mod0"
        d="m31.24,14.68H8.44c-1.66,0-3,1.34-3,3v38.4c0,1.66,1.34,3,3,3h37.08c1.66,0,3-1.34,3-3v-23.4"
      />
      <path
        class="mod0"
        d="m24.4,39.28l8.88-1.2,25.8-26.4h0c.96-1.51.93-3.48-.16-4.89-.63-.81-1.42-1.48-2.33-1.97-1.49-.8-3.31-.63-4.66.39l-.77.59-24.96,24.96-1.8,8.52Z"
      />
      <path class="mod0" d="m47.38,9.58l6.96,6.95-6.96-6.95Z" />
    </svg>
  );
};

export const WBSIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{ height: props.height, margin: props.margin }}
    >
      <style type="text/css">{`.wbs1 {
       fill: none;
       stroke: ${props.color};
       stroke-miterlimit: 10;
       stroke-width: 5px;}
        `}</style>

      <polygon
        class="wbs1"
        points="24.52 3.64 24.52 17.92 32 17.92 39.16 17.92 39.16 3.64 24.52 3.64"
      />
      <rect class="wbs1" x="3.4" y="45.76" width="14.4" height="14.52" />
      <rect class="wbs1" x="24.52" y="46.12" width="14.64" height="14.16" />
      <rect class="wbs1" x="46" y="46.12" width="14.4" height="14.16" />
      <polyline class="wbs1" points="10.6 45.04 10.6 32 53.2 32 53.2 46.12" />
      <line class="wbs1" x1="32" y1="45.76" x2="32" y2="17.92" />
    </svg>
  );
};

export const Delete = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{ height: props.height, margin: props.margin }}
    >
      {/* <title>delete</title> */}
      <style type="text/css">{`
            .del1 {
              stroke-linecap: round;
            }
      
            .del1, .del2 {
              fill: none;
              stroke: ${props.color};
              stroke-miterlimit: 10;
              stroke-width: 5px;
            }
      `}</style>

      <polygon
        class="del2"
        points="18.22 59.97 44.1 59.97 48.99 17.35 13.32 17.35 18.22 59.97"
      />
      <path
        class="del2"
        d="m13.32,17.35l-1.94-.41c-1.57-1.69-1.57-4.72-.01-6.41l1.18-.41h37.98l.85.36c1.97,1.58,1.78,5.24-.33,6.5l-2.07.36"
      />
      <path
        class="del2"
        d="m18.97,11.04v-3.31c0-3.25,2.66-5.91,5.91-5.91h12.38c3.34,0,6.07,2.73,6.07,6.07v3.15"
      />
      <line class="del1" x1="21.95" y1="21.73" x2="25.17" y2="55.46" />
      <line class="del1" x1="31.03" y1="21.73" x2="31.03" y2="55.46" />
      <line class="del1" x1="40.36" y1="21.73" x2="37.66" y2="55.46" />
    </svg>
  );
};

export const Visibility = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      {/* <title>visibility</title> */}
      <style type="text/css">{`
      
      .visib1{fill: none;
        stroke: ${props.color};
        stroke-miterlimit: 10;
        stroke-width: 4px;
        }
        
        `}</style>
      <path
        class="visib1"
        d="m2.66,28.94c6.02,8.39,16.22,13.62,26.54,13.61s20.52-5.25,26.53-13.65c-6.04-8.23-16.33-13.17-26.53-13.21S8.76,20.76,2.66,28.94Z"
      />
      <path
        class="visib1"
        d="m36.61,32.1c.95-2.63.4-5.75-1.4-7.89s-4.77-3.23-7.53-2.76-5.19,2.49-6.17,5.11-.14,5.48,1.6,7.54,4.59,3.13,7.26,2.71,5.32-2.18,6.23-4.72Z"
      />
    </svg>
  );
};

export const AdressBook = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      {/* <title>adressbook</title> */}
      <style type="text/css">{`
      
     
      .adressb1, .adressb2 {
        fill: none;
        stroke: ${props.color};
        stroke-miterlimit: 10;
        stroke-width: 3px;
      }

      .adressb2 {
        stroke-linecap: round;
      }
      
      `}</style>
      <rect
        class="adressb1"
        x="11.53"
        y="1.5"
        width="39.84"
        height="55.8"
        rx="3"
        ry="3"
      />
      <path
        class="adressb1"
        d="m6.97,9.18l-.62.04c-2.02.8-1.72,4.1-.05,4.35l.68.04h7.8l.8-.05c1.66-.43,2.14-3.19.16-4.33l-.73-.05H6.97Z"
      />
      <path
        class="adressb1"
        d="m6.97,26.73l-.62.04c-2.02.8-1.72,4.1-.05,4.35l.68.04h7.8l.8-.05c1.66-.43,2.14-3.19.16-4.33l-.73-.05H6.97Z"
      />
      <path
        class="adressb1"
        d="m6.97,44.28l-.62.04c-2.02.8-1.72,4.1-.05,4.35l.68.04h7.8l.8-.05c1.66-.43,2.14-3.19.16-4.33l-.73-.05H6.97Z"
      />
      <circle class="adressb2" cx="33.74" cy="29.4" r="13.64" />
      <circle class="adressb2" cx="34.04" cy="26.93" r="4.97" />
      <path
        class="adressb2"
        d="m23.81,37.17c2.39-3.15,6.29-5.08,10.24-5.07s7.85,1.96,10.22,5.12"
      />
    </svg>
  );
};
export const KanbanIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <style type="text/css">{` 
      
      .kanban1 {
        stroke-linecap: round;
        stroke-width: 4px;
      }

      .kanban1, .kanban2 {
        fill: none;
        stroke: ${props.color};
        stroke-miterlimit: 10;
      }

      .kanban2 {
        stroke-width: 5px;
      }
      
      `}</style>

      <path
        class="kanban2"
        d="m8.8,11.29h12.3c2.21,0,4,1.7,4,3.8v37.29c0,2.1-1.79,3.8-4,3.8h-12.5c-2.22,0-4.01-1.71-4-3.82l.2-37.29c.01-2.09,1.8-3.78,4-3.78Z"
      />
      <rect
        class="kanban2"
        x="32.06"
        y="11.29"
        width="20.64"
        height="31.2"
        rx="4"
        ry="4"
      />
      <line class="kanban1" x1="4.51" y1="2" x2="25.01" y2="2" />
      <line class="kanban1" x1="31.97" y1="2" x2="52.61" y2="2" />
    </svg>
  );
};

export const TimeIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <style type="text/css">{` 
      
      .time1, .time2 {
        fill: none;
        stroke: ${props.color};
        stroke-miterlimit: 10;
        stroke-width: 5px;
      }

      .time2 {
        stroke-linecap: round;
      }
      
      `}</style>

      <circle class="time1" cx="28.47" cy="28.47" r="26.47" />
      <polyline class="time2" points="26.42 15.51 26.42 32.74 44.03 32.74" />
    </svg>
  );
};

export const Risk = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <style>{`
    .cell {
      fill: white;
      stroke: black;
      stroke-width: 1;
    }
  `}</style>

      {Array.from({ length: 5 }).map((_, row) =>
        Array.from({ length: 5 }).map((_, col) => (
          <rect
            key={`${row}-${col}`}
            class="cell"
            x={col * 20}
            y={row * 20}
            width="20"
            height="20"
          />
        ))
      )}
    </svg>
  );
};

export const Task = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <style type="text/css">{`
           
      .task1 {
        stroke-linecap: round;
      }
      
      .task1, .task2 {
        fill: none;
        stroke: ${props.color};
        stroke-miterlimit: 10;
        stroke-width: 4px;
      }

      `}</style>

      <title xmlns="http://www.w3.org/2000/svg">planning</title>
      <circle class="task2" cx="30.23" cy="30.23" r="28.23" />
      <polyline class="task1" points="15.04 27.61 26.44 39.46 47.86 18.95" />
    </svg>
  );
};

export const Folder = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <style type="text/css">{`
      
      .folder1 {
        fill: none;
        stroke: ${props.color};
        stroke-miterlimit: 10;
        stroke-width: 5px;
      }

      `}</style>

      <title xmlns="http://www.w3.org/2000/svg">folder</title>
      <path
        class="folder1"
        d="m6.17,18.1L30.59,5.11c.88-.47,1.94-.47,2.83,0l24.23,12.98c.71.38.7,1.4-.02,1.77l-24.71,12.7c-.57.29-1.25.29-1.82,0L6.19,19.87c-.72-.37-.73-1.39-.02-1.77Z"
      />
      <path
        class="folder1"
        d="m16.81,38.06l-10.75,6.19c-.68.39-.66,1.39.04,1.75l23.9,12.48c.86.45,1.88.45,2.74.02l24.9-12.61c.72-.36.73-1.38.03-1.77l-10.56-5.84"
      />
      <path
        class="folder1"
        d="m16.39,25.07l-10.26,5.52c-.7.38-.7,1.39,0,1.76l24.85,13.27c.58.31,1.27.31,1.86.01l24.87-12.81c.7-.36.73-1.36.05-1.75l-10.27-5.99"
      />
    </svg>
  );
};

export const FolderBlack = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <style type="text/css">{`.folder-cls-1{fill:${props.color}}`}</style>

      <title xmlns="http://www.w3.org/2000/svg">folder</title>

      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
        <path
          class="folder-cls-1"
          d="M2480 5091 c-30 -16 -588 -306 -1240 -646 -749 -390 -1195 -628
-1212 -646 -18 -19 -28 -40 -28 -60 0 -71 -1 -70 515 -339 l486 -253 -98 -51
c-54 -29 -271 -142 -482 -251 -401 -209 -421 -222 -421 -285 0 -66 -28 -50
1280 -733 954 -499 1253 -651 1280 -651 27 0 189 81 680 338 l645 338 145 -74
c467 -238 751 -391 739 -399 -8 -4 -507 -264 -1109 -579 l-1095 -571 -55 26
c-57 28 -2163 1125 -2168 1130 -2 2 99 56 225 121 125 65 240 130 255 145 61
61 16 174 -68 173 -57 0 -719 -345 -740 -385 -22 -44 -18 -85 14 -118 28 -31
2446 -1298 2509 -1315 30 -9 44 -5 111 28 240 119 2421 1262 2439 1279 32 29
40 82 18 123 -15 29 -79 65 -501 285 l-484 252 232 122 c128 66 345 179 482
250 259 135 286 155 286 215 0 62 -22 77 -378 263 -187 97 -352 177 -366 177
-14 0 -37 -5 -51 -12 -55 -25 -74 -120 -32 -161 12 -13 124 -76 250 -141 125
-66 227 -122 227 -126 0 -4 -497 -266 -1105 -583 l-1105 -577 -1105 577 c-608
317 -1105 580 -1105 583 0 8 866 460 881 460 7 0 301 -151 654 -335 462 -241
652 -335 675 -335 24 0 372 177 1280 651 1112 580 1249 654 1265 683 22 41 14
94 -18 123 -12 11 -544 293 -1182 626 -1349 703 -1318 687 -1347 687 -13 0
-48 -13 -78 -29z m1198 -781 c606 -316 1098 -577 1094 -581 -16 -14 -2200
-1149 -2212 -1149 -11 0 -2195 1134 -2212 1149 -9 7 2202 1162 2218 1159 6 -2
507 -262 1112 -578z"
        />
      </g>
    </svg>
  );
};

export const File = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <style type="text/css">{`.file-cls-1{
      fill:#fff;stroke:${props.color};stroke-miterlimit:10;stroke-width:3px}`}</style>

      <title xmlns="http://www.w3.org/2000/svg">file</title>
      <path
        xmlns="http://www.w3.org/2000/svg"
        class="file-cls-1"
        d="M14.5,6.5l-12,15c-6,7,7,18,14,10l17-21C37,5,28-3,21.5,3.5l-14,18c-3,4,4,9,7,5l13-16c2-3-2-6-4-3l-10,12"
      />
    </svg>
  );
};

export const GanttIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <style type="text/css">{`.gantt1{
       fill: none;
       stroke: ${props.color};
       stroke-linecap: round;
       stroke-miterlimit: 10;
       stroke-width: 5px;}
      `}</style>

      <title xmlns="http://www.w3.org/2000/svg">Gantt</title>
      <path
        class="gantt1"
        d="m7,5.56l-.05,48.94c.03,2.2,1.21,3.28,3.41,3.26l48.36-.24"
      />
      <line class="gantt1" x1="16" y1="15.52" x2="32" y2="15.52" />
      <line class="gantt1" x1="25" y1="29.68" x2="48.16" y2="29.68" />
      <line class="gantt1" x1="42.28" y1="43.72" x2="56.35" y2="43.72" />
    </svg>
  );
};

export const ToDoIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <style type="text/css">{`     
      
      .todolist1, .todolist2 {
        fill: none;
        stroke: ${props.color};
        stroke-miterlimit: 10;
        stroke-width: 5px;
      }

      todolist2 {
        stroke-linecap: round;
      }

      `}</style>

      <title xmlns="http://www.w3.org/2000/svg">Todo</title>
      <path
        class="todolist1"
        d="m16.63,57.64h30.49c2.76,0,5-2.24,5-5V11.4c0-2.76-2.24-5-5-5h-30.87c-2.78,0-5.03,2.27-5,5.05v41.75c.03,2.74,2.64,4.44,5.39,4.44Z"
      />
      <polyline
        class="todolist2"
        points="16.97 30.56 27.41 41.41 47.03 22.63"
      />
    </svg>
  );
};

export const Text = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <style type="text/css">{`
        .text1, .text2 {
          fill: none;
          stroke: ${props.color};
          stroke-miterlimit: 10;
          stroke-width: 5px;
        }
  
        .text2 {
          stroke-linecap: round;
        }
      
      `}</style>

      <title xmlns="http://www.w3.org/2000/svg">text</title>
      <path
        class="text1"
        d="m13.48,5.58v52.84c0,.55.45,1,1,1h35.92c.55,0,1-.45,1-1V19.75c0-.26-.1-.51-.29-.7l-13.94-14.17c-.19-.19-.44-.3-.71-.3H14.48c-.55,0-1,.45-1,1Z"
      />
      <line class="text2" x1="20.44" y1="27.02" x2="46.96" y2="27.02" />
      <line class="text2" x1="20.44" y1="34.94" x2="46.96" y2="34.94" />
      <line class="text2" x1="20.44" y1="42.62" x2="46.96" y2="42.62" />
      <line class="text2" x1="20.44" y1="50.66" x2="46.96" y2="50.66" />
      <path class="text1" d="m37.48,4.58v13.64c0,.55.45,1,1,1h12.92" />
    </svg>
  );
};

export const Backlog = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <style type="text/css">{`.backlog1{fill:none;stroke:${props.color};stroke-miterlimit:10;stroke-width:3px;}.backlog2{fill:${props.color}}`}</style>

      <title xmlns="http://www.w3.org/2000/svg">backlog</title>
      <g xmlns="http://www.w3.org/2000/svg" id="Layer_2" data-name="Layer 2">
        <rect class="backlog1" x="1.5" y="19.76" width="61" height="43" />
      </g>
      <g xmlns="http://www.w3.org/2000/svg" id="Layer_3" data-name="Layer 3">
        <polygon
          class="backlog2"
          points="53.87 0 22.91 44.57 23.07 55 32.91 51.51 63.87 6.94 53.87 0"
        />
      </g>
    </svg>
  );
};

export const Home = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <style type="text/css">{`.home1{
          fill: none;
          stroke: ${props.color};
          stroke-miterlimit: 10;
          stroke-width: 3px;
      }`}</style>
      <title xmlns="http://www.w3.org/2000/svg">backlog</title>
      <path
        class="home1"
        d="m26.32,10.3L7.19,25.76c-2.86,2.31-2.33,6.81.98,8.4l1.87.9.44,17.97c.05,2.17,1.83,3.9,4,3.9h11.58l.19-13.13c.04-3.09,2.48-5.61,5.57-5.76h0c.13,0,.25,0,.38,0h0c3.06.15,5.47,2.67,5.47,5.74v13.15l11.76-.34c2.35,0,4.17.34,3.88-3.92l.37-18.33,1.12-.45c3.54-1.42,4.26-6.11,1.3-8.52l-18.44-15.04c-3.3-2.69-8.03-2.7-11.34-.03Z"
      />
    </svg>
  );
};

export const MoveHorizontal = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 40"
      style={{
        width: props.width,
        margin: props.margin,
      }}
    >
      <style type="text/css">{`.home1{fill:${props.color};}`}</style>
      <title xmlns="http://www.w3.org/2000/svg">move horizontally</title>
      <path
        class="home1"
        d="M1.6,19.3L15.5,4.6c1.1-1.1,3-0.4,3,1.2v8.7h28V6.2c0-1.6,2-2.3,3-1.1l13,15.3c0.6,0.7,0.5,1.7-0.1,2.3l-13,13.7
	c-1.1,1.1-3,0.4-3-1.2v-7.7h-28v7.7c0,1.5-1.9,2.3-3,1.2L1.6,21.7C1,21,1,20,1.6,19.3z"
      />
    </svg>
  );
};

export const DropDown = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        width: props.width,
        margin: props.margin,
      }}
    >
      <style type="text/css">{`.dropdown1{fill:${props.color};}`}</style>
      <title xmlns="http://www.w3.org/2000/svg">DropDown</title>
      <polygon class="dropdown1" points="-0.5,-0.5 64.5,-0.5 31.5,63.5 " />
    </svg>
  );
};

export const Lock = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <style type="text/css">{`
     .lock1 {
      stroke-width: 5px;
    }

    .lock1, .lock2 {
      fill: none;
      stroke: ${props.color};
      stroke-miterlimit: 10;
    }

    .lock2 {
      stroke-width: 4px;
    }
    
    `}</style>
      <title xmlns="http://www.w3.org/2000/svg">Lock</title>

      <path
        class="lock1"
        d="m52.54,32.1v24.69c0,2.2-1.7,4.23-3.9,4.26H15.55c-2.21,0-4.01-1.77-4.03-3.98l-.23-24.65c-.02-2.21,1.76-4.02,3.67-4.59l33.32.05c2.52.54,4.26,1.99,4.26,4.22Z"
      />
      <path
        class="lock1"
        d="m15.94,27.7c-.08-3.44-.1-6.91.49-10.3s1.84-6.73,4.04-9.38c3.13-3.76,8.18-5.83,13.05-5.35s9.42,3.49,11.77,7.78c1.39,2.54,2.02,5.43,2.22,8.32s.3,5.75.08,8.63"
      />
      <path
        class="lock2"
        d="m29.8,49.53c.06.9.83,1.7,1.7,2s1.54.13,2.37-.85c.67-.8.28-1.4.17-2.71-.1-1.24,1.25-2.13,1.81-3.24.99-1.97.09-4.64-1.9-5.64s-4.71-.15-5.76,1.79c-.72,1.35-.54,3.07.29,4.33.37.55,1.13.97,1.32,1.6.25.82-.06,1.92-.01,2.7Z"
      />
    </svg>
  );
};

export const LockWhite = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <style type="text/css">{`
     .lock1 {
      stroke-width: 3px;
    }

    .lock1, .lock2 {
      fill: none;
      stroke: ${props.color};
      stroke-miterlimit: 10;
    }

    .lock2 {
      stroke-width: 2px;
    }
    
    `}</style>
      <title xmlns="http://www.w3.org/2000/svg">Lock</title>

      <path
        class="lock1"
        d="m52.54,32.1v24.69c0,2.2-1.7,4.23-3.9,4.26H15.55c-2.21,0-4.01-1.77-4.03-3.98l-.23-24.65c-.02-2.21,1.76-4.02,3.67-4.59l33.32.05c2.52.54,4.26,1.99,4.26,4.22Z"
      />
      <path
        class="lock1"
        d="m15.94,27.7c-.08-3.44-.1-6.91.49-10.3s1.84-6.73,4.04-9.38c3.13-3.76,8.18-5.83,13.05-5.35s9.42,3.49,11.77,7.78c1.39,2.54,2.02,5.43,2.22,8.32s.3,5.75.08,8.63"
      />
      <path
        class="lock2"
        d="m29.8,49.53c.06.9.83,1.7,1.7,2s1.54.13,2.37-.85c.67-.8.28-1.4.17-2.71-.1-1.24,1.25-2.13,1.81-3.24.99-1.97.09-4.64-1.9-5.64s-4.71-.15-5.76,1.79c-.72,1.35-.54,3.07.29,4.33.37.55,1.13.97,1.32,1.6.25.82-.06,1.92-.01,2.7Z"
      />
    </svg>
  );
};

export const TaskIcon = (props) => {
  return (
    <svg
      id="Calque_23"
      data-name="Calque 23"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <defs>
        <style type="text/css">{`
      .cls-1, .cls-2 {
        fill: none;
        stroke: ${props.color};
        stroke-miterlimit: 10;
        stroke-width: 3px;
      }

      .cls-2 {
        stroke-linecap: round;
      }
      `}</style>
      </defs>
      <path
        class="cls-1"
        d="m13.48,5.58v52.84c0,.55.45,1,1,1h35.92c.55,0,1-.45,1-1V19.75c0-.26-.1-.51-.29-.7l-13.94-14.17c-.19-.19-.44-.3-.71-.3H14.48c-.55,0-1,.45-1,1Z"
      />
      <line class="cls-2" x1="20.44" y1="27.02" x2="46.96" y2="27.02" />
      <line class="cls-2" x1="20.44" y1="34.94" x2="46.96" y2="34.94" />
      <line class="cls-2" x1="20.44" y1="42.62" x2="46.96" y2="42.62" />
      <line class="cls-2" x1="20.44" y1="50.66" x2="46.96" y2="50.66" />
      <path class="cls-1" d="m37.48,4.58v13.64c0,.55.45,1,1,1h12.92" />
    </svg>
  );
};

export const Tableau = (props) => {
  return (
    <svg
      id="Calque_234"
      data-name="Calque 243"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{
        height: props.height,
        margin: props.margin,
      }}
    >
      <defs>
        <style type="text/css">
          {`
      .cls-1 {
        fill: none;
      }

      .cls-1, .cls-2 {
        stroke: ${props.color};
        stroke-miterlimit: 10;
        stroke-width: 3px;
      }

      .cls-2 {
        fill: #fff;
        stroke-linecap: round;
      } `}
        </style>
      </defs>
      <polyline class="cls-2" points="2.68 53.92 58.03 53.92 61.12 53.92" />
      <path
        class="cls-1"
        d="m59.2,53.92V11.88c0-1.1-.9-2-2-2h-9.2c-1.1,0-2,.9-2,2v41.56"
      />
      <path
        class="cls-1"
        d="m38.44,53.92v-31.48c0-1.1-.9-2-2-2h-8.72c-1.1,0-2,.9-2,2v31"
      />
      <path
        class="cls-1"
        d="m17.68,53.92v-22.4c0-.55-.45-1-1-1H5.84c-.55,0-1,.45-1,1v21.92"
      />
    </svg>
  );
};
